"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove0xPrefix = exports.ethAddress = void 0;
const tronweb_1 = __importDefault(require("tronweb"));
exports.ethAddress = {
    toTron: (address) => {
        return tronweb_1.default.address.fromHex("41" + address.substring(2));
    },
    toTronHex: (address) => {
        return "41" + address.substring(2);
    },
    fromTron: (address) => {
        return "0x" + tronweb_1.default.address.toHex(address).substring(2);
    },
    fromTronHex: (address) => {
        return "0x" + address.substring(2);
    }
};
const remove0xPrefix = (address) => {
    return address.substring(2);
};
exports.remove0xPrefix = remove0xPrefix;
